import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    loading: true,
    error: null,
    range: 'week',  // 'day' | 'week' | 'month'
    calls: [],
};

export const analyticDomainDataSlice = createSlice({
    name: 'analyticDomainData',
    initialState,
    reducers: {
        setDomainAnalyticData: (state, action) => {
            const { range, calls = [] } = action.payload || {};
            state.loading = false;
            state.error = null;
            if (range) state.range = range;
            state.calls = calls;
        },
        resetDomainAnalyticData: () => initialState,
    },
});

export const { setDomainAnalyticData, resetDomainAnalyticData } = analyticDomainDataSlice.actions;
export const selectDomainAnalyticData = (state) => state.analyticDomainData;
export default analyticDomainDataSlice.reducer;